import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import axios from '../../../constents/axios'; // Custom axios instance
import { toast } from 'react-toastify';

const extractYouTubeID = (url) => {
  try {
    const regex =
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|v\/))([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match && match[1] ? match[1] : '';
  } catch {
    return '';
  }
};

const EditFreeVideo = ({ show, handleClose, videoData, onSuccess }) => {
  const [loading, setLoading] = useState(false); 
  const [formData, setFormData] = useState({
    id: '',
    title: '',
    subject: '',
    playlist: '',
    url: '',
    yt_id: '',
  });
  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    if (videoData) {
      setFormData({
        id: videoData.id || '',
        title: videoData.title || '',
        subject: videoData.subject || '',
        playlist: videoData.playlist || '',
        url: videoData.url || '',
        yt_id: videoData.yt_id ||'',
      });
    }
  }, [videoData]);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };

  const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === 'url') {
    const youtubeId = extractYouTubeID(value);
    setFormData((prev) => ({
      ...prev,
      url: value,
      yt_id: youtubeId || '',
    }));
  } else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};

  useEffect(() => {
    axios
      .get('/api/get-subjects')
      .then((response) => {
        setSubjects(response.data);
      })
      .catch((error) => {
        console.error('Error fetching subjects:', error);
      });
  }, []);
const handleSave = async () => {
  try {
        setLoading(true);

    const response = await axios.put(`/api/edit-FreeVideo/${formData.id}`, formData);
    console.log(response.data, "data");

    if (response.status === 200) {
      console.log('Edit successful:', response.data);

      toast.success('Video updated successfully!', {
        position: 'top-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      onSuccess?.(formData);

      setTimeout(() => {
        handleClose();
      }, 1000);
    } else {
      alert(response?.data?.message || 'Failed to update video');
    }
  } catch (error) {
    console.error('Error updating Free Video:', error);
    toast.error('Something went wrong while updating the video.');
  }finally{
        setLoading(false);
  }
};


  if (!videoData) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit  YouTubeVideo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>ID</Form.Label>
            <Form.Control type="text" name="id" value={formData.id} disabled />
          </Form.Group>

         <Form.Group className="mb-3">
  <Form.Label>YouTube ID</Form.Label>
  <Form.Control
    type="text"
    name="yt_id"
    value={formData.yt_id}
    onChange={handleChange}
    disabled
  />
</Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter title"
            />
          </Form.Group>

          <Form.Group className="mb-3">
                    <Form.Label>Subject</Form.Label>
                    <Form.Select
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                    >
                      <option value="">Select Subject</option>
                      {subjects.map((subject, idx) => (
                        <option key={idx} value={subject}>
                          {subject}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
{/* 
          <Form.Group className="mb-3">
            <Form.Label>Playlist</Form.Label>
            <Form.Control
              type="text"
              name="playlist"
              value={formData.playlist}
              onChange={handleChange}
              placeholder="Enter playlist"
            />
          </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label>Video URL</Form.Label>
            <Form.Control
              type="text"
              name="url"
              value={formData.url}
              onChange={handleChange}
              placeholder="Enter video URL"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
            <Button variant="primary" onClick={handleSave} disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Saving...
            </>
          ) : (
            'Save Changes'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditFreeVideo;
